import { Fragment } from 'react'
import {
  List,
  Datagrid,
  TextField,
  DateField,
  EditButton,
  ReferenceField,
  DeleteButton,
  ReferenceInput,
  SelectInput,
  TextInput,
  TopToolbar,
  CreateButton,
  ExportButton,
  usePermissions,
  useRecordContext,
  useListContext,
} from 'react-admin'

import EnglishBookActionButton from '../../components/EnglishBookActionButton'
import EnglishBookStatusField from '../../components/EnglishBookStatusField'
import FilterComponent from '../../components/Filter'
import { ROLES } from '../../components/constants'

const Actions = () => {
  const { resource, currentSort, filterValues, exporter, basePath } =
    useListContext()
  return (
    <TopToolbar>
      <CreateButton basePath={basePath} />
      <ExportButton
        disabled={false}
        resource={resource}
        sort={currentSort}
        filter={filterValues}
        exporter={exporter}
        maxResults={10000}
      />
    </TopToolbar>
  )
}

const EnglishBookFilter = props => (
  <FilterComponent {...props}>
    <TextInput label="Search by title" source="title" alwaysOn />
    <ReferenceInput
      label="Publisher"
      source="publisherId"
      reference="users"
      filter={{ role: 'publisher' }}
      alwaysOn>
      <SelectInput
        optionText="name"
        options={{
          fullWidth: true,
        }}
      />
    </ReferenceInput>
    <ReferenceInput
      label="Author"
      source="authorId"
      reference="authors"
      alwaysOn>
      <SelectInput
        optionText="name"
        options={{
          fullWidth: true,
        }}
      />
    </ReferenceInput>
  </FilterComponent>
)

const ActionField = () => {
  const { permissions } = usePermissions()
  const record = useRecordContext()
  if (!record || permissions !== ROLES.ADMIN) return null

  switch (record.status) {
    case 'Under review':
      return (
        <Fragment>
          <EnglishBookActionButton
            label="Approve"
            action="approve"
            variant="contained"
            record={record}
          />
          <EnglishBookActionButton
            label="Reject"
            action="reject"
            variant="error"
            record={record}
          />
        </Fragment>
      )

    default:
      return <DeleteButton label="Delete" record={record} />
  }
}

const EnglishBookList = ({ ...props }) => {
  const { permissions } = usePermissions()
  console.log('🚀 ~ EnglishBookList ~ permissions:', permissions)
  return (
    <List
      {...props}
      filters={<EnglishBookFilter />}
      actions={<Actions />}
      sort={{ field: 'updatedAt', order: 'DESC' }}>
      <Datagrid
        bulkActionButtons={false}
        rowClick={false}
        bulkActionButtons={false}>
        <TextField source="title" />
        <ReferenceField source="authorId" reference="authors" label="Author">
          <TextField source="name" />
        </ReferenceField>
        <ReferenceField
          source="publisherId"
          reference="users"
          label="Publisher">
          <TextField source="name" />
        </ReferenceField>
        <DateField source="datePublished" label="Publish Date" />
        <ReferenceField label="Created by" source="createdBy" reference="users">
          <TextField source="name" />
        </ReferenceField>
        <ReferenceField label="Updated by" source="updatedBy" reference="users">
          <TextField source="name" />
        </ReferenceField>
        <DateField source="createdAt" />
        <DateField source="updatedAt" />
        <EnglishBookStatusField disabled={permissions !== ROLES.ADMIN} />
        <EditButton />
        <ActionField />
      </Datagrid>
    </List>
  )
}

export default EnglishBookList
